/* Local dependencies */
import { CreateOrderFormFields, ValidationAllFieldsOptions, ValidationErrors } from './types';

export function validateOrder(order: CreateOrderFormFields, options: ValidationAllFieldsOptions = {}): ValidationErrors {
  const errors: ValidationErrors = {};

  if (options.requireUser && !order.userId?.trim()) {
    errors.userId = 'dashboard-order-user-required';
  }

  if (options.requireWarehouse && !order.warehouseId?.trim()) {
    errors.warehouseId = 'dashboard-order-warehouse-required';
  }

  if (!order.trackingNumber || !order.trackingNumber.trim()) {
    errors.trackingNumber = 'dashboard-tracking-number-required';
  }

  if (!order.name || !order.name.trim()) {
    errors.name = 'dashboard-package-contents-required';
  }

  if (order.amount.amount === 0) {
    errors.amount = 'dashboard-price-required';
  } else {
    const amount = typeof order.amount.amount === 'string' ? parseFloat(order.amount.amount) : order.amount.amount;

    if (isNaN(amount) || amount <= 0) {
      errors.amount = 'dashboard-invalid-price';
    }
  }

  if (order.parcelCount === 0) {
    errors.parcelCount = 'dashboard-parcel-count-required';
  } else {
    const count = typeof order.parcelCount === 'string' ? parseInt(order.parcelCount, 10) : order.parcelCount;

    if (isNaN(count) || count <= 0) {
      errors.parcelCount = 'dashboard-invalid-parcel-count';
    }
  }

  if (!order.deliveryAddress?.address || !order.deliveryAddress.address.trim()) {
    errors.deliveryAddress = 'dashboard-delivery-address-required';
  }

  return errors;
}
